import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { contractsSchema } from '../../../common/validations'

import { get } from 'api/apiClient'

export const getContractsQueryKey = () => ['contracts'] as const

const params = {
  queryKey: getContractsQueryKey(),
  queryFn: () => get(API_ENDPOINTS.CONTRACTS, contractsSchema),
}

export const useAPIGetContracts = () => useQuery(params)

export const useAPIGetContractsSuspense = () => useSuspenseQuery(params)
